module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrBold.381869b.ttf";